export default {
  namespaced: true,
  state: {
    foodSelect: [],
    foodSelectFlag: false,
    blogSelect: [],
    blogSelectFlag: false,
    sicknessSelect: [],
    sicknessSelectFlag: false,
    foodUnitSelect: [],
    foodUnitSelectFlag: false,
    colorSelect: [],
    colorSelectFlag: false,
    foodMealSelect: [],
    foodMealSelectFlag: false,
    couponSelect: [],
    couponSelectFlag: false,
    foodCategorySelect: [],
    foodCategorySelectFlag: false,
    specialDietSelect: [],
    specialDietSelectFlag: false,
    activityCategorySelect: [],
    activityCategorySelectFlag: false,
    blogCategorySelect: [],
    blogCategorySelectFlag: false,
    projectCategorySelect: [],
    projectCategorySelectFlag: false,
    productCategorySelect: [],
    productCategorySelectFlag: false,
    productSelect: [],
    productSelectFlag: false,
    brandSelect: [],
    brandSelectFlag: false,
    guarantySelect: [],
    guarantySelectFlag: false,
    styleSelect: [],
    styleSelectFlag: false,
    divisionSelect: [],
    divisionSelectFlag: false,
    faqCategorySelect: [],
    faqCategorySelectFlag: false,
    activityGroupSelect: [],
    activityGroupSelectFlag: false,
    activityPackageSelect: [],
    activityPackageSelectFlag: false,
    activityPackageCourseSelect: [],
    activityPackageCourseSelectFlag: false,
    activitySelect: [],
    activitySelectFlag: false,
    muscleSelect: [],
    muscleSelectFlag: false,
    sicknessCategorySelect: [],
    sicknessCategorySelectFlag: false,
    bannerPositionSelect: [],
    bannerPositionSelectFlag: false,
    departmentSelect: [],
    departmentSelectFlag: false,
    dietDurationPriceSelect: [],
    dietDurationPriceFlag: false,
    listFilter: { },
    specialDietFoodListSelect: [],
    specialDietFoodListSelectFlag: false,
    recommendCategorySelect: [],
    recommendCategorySelectFlag: false,
    foodRecipesSelect: [],
    foodRecipesSelectFlag: false,
  },
  getters: {
  },
  mutations: {
    setFoodSelect: (state, payload) => {
      state.foodSelect = Object.freeze(payload)
    },
    setFoodSelectFlag: (state, payload) => {
      state.foodSelectFlag = payload
    },
    setSicknessSelect: (state, payload) => {
      state.sicknessSelect = Object.freeze(payload)
    },
    setSicknessSelectFlag: (state, payload) => {
      state.sicknessSelectFlag = payload
    },
    setFoodUnitSelect: (state, payload) => {
      state.foodUnitSelect = Object.freeze(payload)
    },
    setFoodUnitSelectFlag: (state, payload) => {
      state.foodUnitSelectFlag = payload
    },
    setColorSelect: (state, payload) => {
      state.colorSelect = Object.freeze(payload)
    },
    setColorSelectFlag: (state, payload) => {
      state.colorSelectFlag = payload
    },
    setFoodMealSelect: (state, payload) => {
      state.foodMealSelect = Object.freeze(payload)
    },
    setFoodMealSelectFlag: (state, payload) => {
      state.foodMealSelectFlag = payload
    },
    setCouponSelect: (state, payload) => {
      state.couponSelect = Object.freeze(payload)
    },
    setCouponSelectFlag: (state, payload) => {
      state.couponSelectFlag = payload
    },
    setFoodCategorySelect: (state, payload) => {
      state.foodCategorySelect = Object.freeze(payload)
    },
    setFoodCategorySelectFlag: (state, payload) => {
      state.foodCategorySelectFlag = payload
    },
    setActivityCategorySelect: (state, payload) => {
      state.activityCategorySelect = Object.freeze(payload)
    },
    setActivityCategorySelectFlag: (state, payload) => {
      state.activityCategorySelectFlag = payload
    },
    setBlogCategorySelect: (state, payload) => {
      state.blogCategorySelect = Object.freeze(payload)
    },
    setBlogCategorySelectFlag: (state, payload) => {
      state.blogCategorySelectFlag = payload
    },
    setProjectCategorySelect: (state, payload) => {
      state.projectCategorySelect = Object.freeze(payload)
    },
    setProjectCategorySelectFlag: (state, payload) => {
      state.projectCategorySelectFlag = payload
    },
    setProductCategorySelect: (state, payload) => {
      state.productCategorySelect = Object.freeze(payload)
    },
    setProductCategorySelectFlag: (state, payload) => {
      state.productCategorySelectFlag = payload
    },
    setProductSelect: (state, payload) => {
      state.productSelect = Object.freeze(payload)
    },
    setProductSelectFlag: (state, payload) => {
      state.productSelectFlag = payload
    },
    setBrandSelect: (state, payload) => {
      state.brandSelect = Object.freeze(payload)
    },
    setBrandSelectFlag: (state, payload) => {
      state.brandSelectFlag = payload
    },
    setGuarantySelect: (state, payload) => {
      state.guarantySelect = Object.freeze(payload)
    },
    setGuarantySelectFlag: (state, payload) => {
      state.guarantySelectFlag = payload
    },
    setStyleSelect: (state, payload) => {
      state.styleSelect = Object.freeze(payload)
    },
    setStyleSelectFlag: (state, payload) => {
      state.styleSelectFlag = payload
    },
    setDivisionSelect: (state, payload) => {
      state.divisionSelect = Object.freeze(payload)
    },
    setDivisionSelectFlag: (state, payload) => {
      state.divisionSelectFlag = payload
    },
    setFaqCategorySelect: (state, payload) => {
      state.faqCategorySelect = Object.freeze(payload)
    },
    setFaqCategorySelectFlag: (state, payload) => {
      state.faqCategorySelectFlag = payload
    },
    setActivityGroupSelect: (state, payload) => {
      state.activityGroupSelect = Object.freeze(payload)
    },
    setActivityGroupSelectFlag: (state, payload) => {
      state.activityGroupSelectFlag = payload
    },
    setActivityPackageSelect: (state, payload) => {
      state.activityPackageSelect = Object.freeze(payload)
    },
    setActivityPackageSelectFlag: (state, payload) => {
      state.activityPackageSelectFlag = payload
    },
    setActivityPackageCourseSelect: (state, payload) => {
      state.activityPackageCourseSelect = Object.freeze(payload)
    },
    setActivityPackageCourseSelectFlag: (state, payload) => {
      state.activityPackageCourseSelectFlag = payload
    },
    setActivitySelect: (state, payload) => {
      state.activitySelect = Object.freeze(payload)
    },
    setActivitySelectFlag: (state, payload) => {
      state.activitySelectFlag = payload
    },
    setDepartmentSelect: (state, payload) => {
      state.departmentSelect = Object.freeze(payload)
    },
    setDepartmentSelectFlag: (state, payload) => {
      state.departmentSelectFlag = payload
    },
    setListFilter: (state, payload) => {
      state.listFilter[payload.key] = payload.value
    },
    setDietDurationPriceFlag: (state, payload) => {
      state.dietDurationPriceFlag = payload
    },
    setDietDurationPriceSelect: (state, payload) => {
      state.dietDurationPriceSelect = Object.freeze(payload)
    },
    setMuscleSelectFlag: (state, payload) => {
      state.muscleSelectFlag = payload
    },
    setMuscleSelect: (state, payload) => {
      state.muscleSelect = Object.freeze(payload)
    },
    setSicknessCategorySelectFlag: (state, payload) => {
      state.sicknessCategorySelectFlag = payload
    },
    setSicknessCategorySelect: (state, payload) => {
      state.SicknessCategorySelect = Object.freeze(payload)
    },
    setBannerPositionFlag: (state, payload) => {
      state.bannerPositionFlag = payload
    },
    setBannerPositionSelect: (state, payload) => {
      state.bannerPositionSelect = Object.freeze(payload)
    },
    setSpecialDietFoodListSelectFlag: (state, payload) => {
      state.specialDietFoodListSelectFlag = payload
    },
    setSpecialDietFoodListSelect: (state, payload) => {
      state.specialDietFoodListSelect = Object.freeze(payload)
    },
    setRecommendCategorySelectFlag: (state, payload) => {
      state.recommendCategorySelectFlag = payload
    },
    setRecommendCategorySelect: (state, payload) => {
      state.recommendCategorySelect = Object.freeze(payload)
    },
    setBlogSelectFlag: (state, payload) => {
      state.blogelectFlag = payload
    },
    setBlogSelect: (state, payload) => {
      state.blogSelect = Object.freeze(payload)
    },
    setFoodRecipesSelect: (state, payload) => {
      state.foodRecipesSelect = Object.freeze(payload)
    },
    setFoodRecipesSelectFlag: (state, payload) => {
      state.foodRecipesSelectFlag = payload
    },
    setSpecialDietSelect: (state, payload) => {
      state.specialDietSelect = Object.freeze(payload)
    },
    setSpecialDietSelectFlag: (state, payload) => {
      state.specialDietSelectFlag = payload
    },
  },
  actions: {},
}
